var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-text-centered"},[(_vm.config.src)?_c('iframe',{attrs:{"src":_vm.config.src,"height":_vm.height,"width":_vm.width}}):_vm._e(),(_vm.config.srcdoc)?_c('iframe',{attrs:{"srcdoc":_vm.config.srcdoc,"height":_vm.height,"width":_vm.width}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }